<template>
  <div>
    <d-form-row class="form-group">
      <d-col cols="12">
        <label>Texto/palavras:</label>
        <textarea
          class="form-control"
          v-model="model.data.words"
          rows="5"
        ></textarea>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12" class="mb-3">
        <label>Grid:</label>
        <textarea
          class="form-control"
          v-model="model.data.grid"
          rows="10"
          @change="setTableByText"
        ></textarea>
      </d-col>
    </d-form-row>
  </div>
</template>

<script>
import { cloneDeep } from '_utils';
import UploadImage from '_shared/UploadImage.vue';
import { MODEL } from '../PuzzleModel';

const data = {
  grid: '',
  table: '',
  words: '',
};

const PUZZLE = { ...MODEL, ...{ data } };

export default {
  name: 'Letrex-puzzle',
  components: {
    UploadImage,
  },
  props: {
    model: {
      type: Object,
      require: true,
      default: () => cloneDeep(PUZZLE),
    },
  },
  methods: {
    setTableByText() {
      const table = this.model.data.grid.split('\n');
      let id = 0;
      /* eslint-disable */
      this.model.data.table = table.map(rows => {
        const columns = rows.split('');
        return columns.map(cell => ({
          id: id += 1,
          word: cell,
        }))
      });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>
